import { Inject, Injectable, Output, EventEmitter } from '@angular/core';
import { BaseEndpoint } from '../app.constants';
import { Headers, Http } from '@angular/http';
import { AdalService } from '../shared/azure-authentication/adal.service';
import { CondoSkillset, UserCondoSkillset } from './condoSkillset.model';

@Injectable()
export class CondoSkillsetsService {
    @Output() requestAdded = new EventEmitter<any[]>();
    @Output() skillsetAdded = new EventEmitter<any>();
    @Output() skillsetUpdated = new EventEmitter<any>();
    @Output() skillsetDeleted = new EventEmitter<any>();

    constructor(private http: Http, @Inject(BaseEndpoint) private baseApiUrl: string, private adalService: AdalService) { }

    getCondoSkillsets(): Promise<CondoSkillset[]> {
        var url = this.baseApiUrl + 'v1/condoskillset/readcollection';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var strats = resp.json().body as CondoSkillset[];
                var assignmentStrategiesR = JSON.parse(JSON.stringify(strats));
                return assignmentStrategiesR;
            })
            .catch(this.handleError);
    }

    getUserCondoSkillsets(userId: string): Promise<UserCondoSkillset[]> {
        var url = this.baseApiUrl + 'v1/usercondoskillset/readcollection/' + userId;
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var regions = resp.json().body as UserCondoSkillset[];
                var parsedRegions = JSON.parse(JSON.stringify(regions));
                return parsedRegions;
            })
            .catch(this.handleError);
    }

    saveAssignedCondoSkillsets(userId: string, loggedInUser: string, userCondoSkillsets: CondoSkillset[]): Promise<UserCondoSkillset[]> {
        var url = this.baseApiUrl + 'v1/usercondoskillset/update/' + userId + '/' + loggedInUser;
        return this.http
            .post(url, JSON.stringify(userCondoSkillsets), { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var strats = resp.json().body as UserCondoSkillset[];
                var assignmentStrategiesR = JSON.parse(JSON.stringify(strats));
                return assignmentStrategiesR;
            })
            .catch(this.handleError);
    }

    private handleError(errors: string[]): Promise<any> {
        console.error('An error occurred', errors);
        return Promise.reject(errors);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/condoskillsets/condoskillsets.service.ts